import { FONT_BASE } from 'game/constants/AppFonts';

// Expected fields:
// quote_header
// quote_from
// quote_source
// quote_date
// quote_body

export class DisplayDocumentQuote extends Phaser.GameObjects.Container {
  constructor(scene, data) {
    super(scene);
    scene.add.existing(this);

    this.x = 0;
    this.y = 250;

    this._data = data;
    this.addDocumentDetails();
  }

  addDocumentDetails() {
    const {
      quote_header = '',
      quote_from = '',
      quote_source = '',
      quote_date = '',
      quote_body = '',
    } = this._data;

    this.open_quotes = this.scene.add.sprite(20, 30, 'ui', 'open_quotes').setOrigin(0);

    this.quote_header = this.scene.add
      .text(this.open_quotes.x + this.open_quotes.width + 5, 25, quote_header, {
        fontFamily: FONT_BASE.OPEN_SANS_BOLD,
        fontSize: '55px',
        color: '#000000',
      })
      .setOrigin(0);

    this.close_quotes = this.scene.add
      .sprite(this.quote_header.x + this.quote_header.width + 5, 30, 'ui', 'close_quotes')
      .setOrigin(0);

    this.topLine = this.scene.add.rectangle(20, 103, 878, 1, 0x000000).setOrigin(0);

    this.quote_from = this.scene.add
      .text(20, 112, quote_from, {
        fontFamily: FONT_BASE.OPEN_SANS_BOLD,
        fontSize: '22px',
        color: '#000000',
      })
      .setOrigin(0);

    const sourceText = quote_source !== '' ? `/ ${quote_source}` : '';

    this.quote_source = this.scene.add
      .text(this.quote_from.x + this.quote_from.width + 4, 112, sourceText, {
        fontFamily: FONT_BASE.OPEN_SANS_BOLD,
        fontSize: '22px',
        color: '#000000',
      })
      .setOrigin(0);

    const dateText = quote_date !== '' ? `/ ${quote_date}` : '';

    this.quote_date = this.scene.add
      .text(this.quote_source.x + this.quote_source.width + 4, 112, dateText, {
        fontFamily: FONT_BASE.OPEN_SANS_BOLD,
        fontSize: '22px',
        color: '#000000',
      })
      .setOrigin(0);

    this.bottomLine = this.scene.add.rectangle(20, 142, 878, 1, 0x000000).setOrigin(0);

    this.body = this.scene.add
      .text(20, 157, quote_body, {
        fontFamily: FONT_BASE.OPEN_SANS_REGULAR,
        fontSize: '22px',
        color: '#000000',
        wordWrap: { width: 874 },
      })
      .setOrigin(0);

    this.add([
      this.open_quotes,
      this.quote_header,
      this.close_quotes,
      this.quote_from,
      this.quote_source,
      this.quote_date,
      this.topLine,
      this.bottomLine,
      this.body,
    ]);
  }

  shutdown() {
    this.destroy();
  }
}
